import ApiOfficeEmployeeProfile from "@rmp/core/api/types/account/profile/apiOfficeEmployeeProfile";
import { ProfileType } from "@rmp/core/types/ProfileType";

export function isApiOfficeEmployeeProfile(profile: any): profile is ApiOfficeEmployeeProfile {
	return (
		profile?.type === ProfileType.OFFICE_EMPLOYEE &&
		typeof profile.divisionId === "string"
	);
}
